import combine from '../services/combine-service';

const employees = {
  employees: [],
  active: [],
  hradmins: [],
  lsadmins: [],
  jtadmins: []
};
export default function(state = employees, action) {
  var newemps;
  switch (action.type) {
    case 'edfemployees - employees':
      newemps = populate(action.payload);
      return {
        ...state,
        active: newemps.activeEmployees,
        employees: action.payload,
        hradmins: newemps.hr_admins,
        lsadmins: newemps.ls_admins,
        jtadmins: newemps.jt_admins
      };
      break;
    case 'Update > edfemployees':
      let edfemps = combine(
        state.employees,
        action.payload,
        'empnumber',
        action.deletestatus
      );
      newemps = populate(edfemps);
      return {
        ...state,
        active: newemps.activeEmployees,
        employees: edfemps,
        hradmins: newemps.hr_admins,
        lsadmins: newemps.ls_admins,
        jtadmins: newemps.jt_admins
      };
      break;
    default:
  }

  return state;
}
const populate = newemps => {
  let hr_admins = [];
  let jt_admins = [];
  let ls_admins = [];
  let activeEmployees = [];
  newemps.map(emp => {
    if (emp.hradmin === 1) {
      hr_admins = hr_admins.concat(emp);
    }
    if (emp.jtadmin === 1) {
      jt_admins = jt_admins.concat(emp);
    }
    if (emp.lsadmin === 1) {
      ls_admins = ls_admins.concat(emp);
    }
    if (emp.status === 'A') {
      activeEmployees = activeEmployees.concat(emp);
    }
  });
  return { hr_admins, jt_admins, ls_admins, activeEmployees };
};



// WEBPACK FOOTER //
// ./src/reducers/employees-reducer.js